import { createRouter, createWebHistory } from 'vue-router'
import Home from '../pages/Home.vue'
import DataSearch from '../pages/DataSearch.vue'
import Tools from '../pages/Tools.vue'
import DataDownload from '../pages/DataDownload.vue'
import DataSubmit from '../pages/DataSubmit.vue'
import About from '../pages/About.vue'
import Help from '../pages/Help.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/search',
    name: 'DataSearch',
    component: DataSearch
  },
  {
    path: '/tools',
    name: 'Tools',
    component: Tools
  },
  {
    path: '/download',
    name: 'DataDownload',
    component: DataDownload
  },
  {
    path: '/submit',
    name: 'DataSubmit',
    component: DataSubmit
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/help',
    name: 'Help',
    component: Help
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router